import { Styles, css, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { Variants } from 'motion/react';

export const threadVariants = {
  initial: { opacity: 0, scaleX: 0 },
  animate: {
    opacity: 1,
    scaleX: 1,
    transition: {
      duration: 0.66,
      ease: [0.22, 0.9, 0.53, 1],
      staggerChildren: 0.03,
      staggerDirection: -1,
    },
  },
} satisfies Variants;

export const historyCardVariants = {
  initial: { opacity: 0, scaleY: 0 },
  animate: { opacity: 1, scaleY: 1 },
} satisfies Variants;

const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    min-width: 0;
    height: 100%;
  `,
  list: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    gap: 12px;
    padding: 12px 35px;

    ${verticalScrollCss(theme)}
  `,
  listLoading: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
  `,
  thread: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
